export default [{
  name: 'uber',
  value: 111,
  unit: 'px',
  lineHeight: 1.08
}, {
  name: 'hero',
  value: 77,
  unit: 'px',
  lineHeight: 1.11
}, {
  name: 'h1',
  value: 34,
  unit: 'px',
  lineHeight: 1.2
}, {
  name: 'h2',
  value: 28,
  unit: 'px',
  lineHeight: 1.23
}, {
  name: 'h3',
  value: 24,
  unit: 'px',
  lineHeight: 1.26
}, {
  name: 'h4',
  value: 21,
  unit: 'px',
  lineHeight: 1.26
}, {
  name: 'h5',
  value: 17,
  unit: 'px',
  lineHeight: 1.268
}, {
  name: 'lead',
  value: 24,
  unit: 'px',
  lineHeight: 1.29
}, {
  name: 'body',
  value: 14,
  unit: 'px',
  lineHeight: 1.6
}, {
  name: 'small',
  value: 12,
  unit: 'px',
  lineHeight: 1.33
}, {
  name: 'caption',
  value: 12,
  unit: 'px',
  lineHeight: 1.22
}, {
  name: 'tiny',
  value: 10,
  unit: 'px',
  lineHeight: 1.38
}];